import { onGetMe as u } from "./onGetMe.js";
var h = (o, l, e) => new Promise((n, r) => {
  var a = t => {
      try {
        c(e.next(t));
      } catch (i) {
        r(i);
      }
    },
    s = t => {
      try {
        c(e.throw(t));
      } catch (i) {
        r(i);
      }
    },
    c = t => t.done ? n(t.value) : Promise.resolve(t.value).then(a, s);
  c((e = e.apply(o, l)).next());
});
const p = (o, l) => h(void 0, null, function* () {
  let e = {};
  try {
    const n = yield fetch("https://apigw.olx.com.br/v2/me?X-OLX-TEAM-KEY=".concat(o != null ? o : "hQIPDF7Bfpw2WJUDwr9GV21jIoDSEJGl"), {
      credentials: "include",
      signal: l
    });
    if (n.status !== 200) return e;
    const r = yield n.json();
    if (!r) return e;
    e = r, u(e);
  } catch (n) {}
  return e;
});
export { p as getMe };